import { CherryPayApi } from "../api/models";

const getStatusColorScheme = (
  status?: CherryPayApi.NotificationScheduleStatus
): string => {
  switch (status) {
    case "Draft":
      return "#807C83";
    case "Scheduled":
      return "#EFC416";
    case "Sent":
      return "#5ABB5E";
    case "Cancelled":
      return "#DC0000";
    default:
      return "gray.500";
  }
};

const NotificationUtil = {
  getStatusColorScheme,
};

export default NotificationUtil;
